export const GET_EMAIL_THREADS = gql`
  query GetEmailThreads(
    $input: GetEmailThreadsInput
    $pageInfo: PageInfoInput
  ) {
    getEmailThreads(input: $input, pageInfo: $pageInfo) {
      items {
        emailThreadId
        threadId
        lastSubject
        lastSnippet
        lastBody
        lastDate
        status
        applicant {
          applicantId
          firstName
          lastName
        }
        emails {
          emailId
          subject
          body
          snippet
          direction
          status
          provider
          from
          to
          cc
          bcc
          date
          createdAt
          updatedAt
        }
      }
      totalCount
      pageInfo {
        limit
        offset
      }
    }
  }
`

export const GET_EMAIL_THREAD_BY_ID = gql`
  query GetEmailThreadById($emailThreadId: String!) {
    getEmailThreadById(emailThreadId: $emailThreadId) {
      emailThreadId
      threadId
      emails {
        emailId
        subject
        body
        snippet
        direction
        status
        provider
        from
        to
        cc
        bcc
        date
        createdAt
        attachments {
          documentId
          fileName
          fileType
        }
        applicant {
          applicantId
          firstName
          lastName
        }
        employee {
          employeeId
          firstName
          lastName
        }
      }
      lastSubject
      lastSnippet
      lastBody
      lastDate
      status
    }
  }
`
